export const heroContent = {
  eyebrow: "DecorZoom events across Delhi NCR",
  title: "Book decoration and banquet in one place.",
  subtitle:
    "Find verified banquet options near you, choose beautiful decoration themes, and get quick WhatsApp support from DecorZoom.",
  image: "/images/home-preview-v2/hero-banner.webp",
  fallbackImage: "/images/premium-jungle-birthday-stage-decoration-with-led-name-board-delhi-decorzoom-7284.webp",
};

export const heroStats = [
  { value: "50+", label: "guest banquet planning" },
  { value: "Rs. 750", label: "per person starting*" },
  { value: "150+", label: "decor options network" },
];

export const mainCategories = [
  {
    title: "Search Banquet",
    text: "Find verified banquet options near you for family functions and celebrations.",
    price: "Starting from Rs. 750 per person*",
    cta: "Search Banquets",
    link: "/banquets",
    image: "/images/home-preview-v2/banquet-featured.webp",
    featured: true,
  },
  {
    title: "Birthday Decoration",
    text: "Balloon, theme, and backdrop setups for home, banquet, and terrace parties.",
    price: "Starting from Rs. 3,500*",
    cta: "Explore Birthday Decor",
    link: "/subcategory/birthday-decoration",
    image: "/images/home-preview-v2/birthday-decoration.webp",
  },
  {
    title: "First Birthday",
    text: "Premium milestone themes with stage decor, LED names, props, and photo corners.",
    price: "Starting from Rs. 7,500*",
    cta: "Explore First Birthday Decor",
    link: "/subcategory/first-birthday-decorations",
    image: "/images/home-preview-v2/first-birthday.webp",
  },
  {
    title: "Baby Shower",
    text: "Elegant godh bharai and baby shower styling for warm family celebrations.",
    price: "Starting from Rs. 5,500*",
    cta: "Explore Baby Shower Decor",
    link: "/subcategory/baby-shower-decoration",
    image: "/images/home-preview-v2/baby-shower.webp",
  },
  {
    title: "Welcome Baby",
    text: "Soft, cute home setups for welcoming your newborn with close family.",
    price: "Starting from Rs. 4,500*",
    cta: "Explore Welcome Baby Decor",
    link: "/subcategory/welcome-baby-decoration",
    image: "/images/home-preview-v2/welcome-baby.webp",
  },
  {
    title: "Wedding Events",
    text: "Haldi, mehendi, engagement, reception, bride entry, and family event styling.",
    cta: "Explore Wedding Services",
    link: "/subcategory/wedding-events",
    image: "/images/home-preview-v2/wedding-events.webp",
  },
  {
    title: "Cake Table Setup",
    text: "Coordinated cake tables, theme props, balloons, and dessert table styling.",
    price: "Starting from Rs. 3,500*",
    cta: "Explore Cake Setups",
    link: "/subcategory/theme-cake-tables",
    image: "/images/home-preview-v2/cake-table-setup.webp",
  },
  {
    title: "Return Gifts",
    text: "Curated gift hampers that make every guest leave with a smile.",
    price: "Custom options available*",
    cta: "Explore Return Gifts",
    link: "/subcategory/return-gifts",
    image: "/images/home-preview-v2/return-gifts.webp",
  },
  {
    title: "Birthday Activities",
    text: "Magic show, tattoo artist, game coordinator, mascot entry, anchor, and more.",
    price: "Add-on services available*",
    cta: "Explore Activities",
    link: "/subcategory/activities",
    image: "/images/home-preview-v2/birthday-activities.webp",
  },
];

export const smallCategories = [
  { label: "Theme Cakes", link: "/subcategory/theme-cakes" },
  { label: "Ring Decoration", link: "/subcategory/ring-decoration" },
  { label: "Anniversary Decoration", link: "/subcategory/anniversary-decoration" },
  { label: "Bride Entry", link: "/subcategory/bride-entry" },
  { label: "Groom Entry", link: "/subcategory/groom-entry" },
  { label: "Photography", link: "/subcategory/photography" },
  { label: "Videography", link: "/subcategory/videography" },
  { label: "Anchor / Emcee", link: "/subcategory/anchor-emcee" },
  { label: "Mascot Entry", link: "/subcategory/mascot-entry" },
  { label: "Face Painting", link: "/subcategory/face-painting" },
  { label: "Tattoo Artist", link: "/subcategory/tattoo-artist" },
  { label: "Game Coordinator", link: "/subcategory/game-coordinator" },
];

export const featuredServices = [
  {
    title: "Birthday, baby shower, wedding and family event specialists",
    detail: "DecorZoom helps customers plan the key celebration moments families actually book.",
  },
  {
    title: "Banquet and decor together",
    detail: "Shortlist venues by guest count, budget, and event flow, then match the setup to the space.",
  },
  {
    title: "Quick WhatsApp support",
    detail: "Get fast guidance on theme, availability, pricing, and next steps from the DecorZoom team.",
  },
];

export const trustBlocks = [
  "Verified event specialists",
  "Delhi NCR coverage",
  "Clear starting prices",
  "WhatsApp booking support",
  "Banquet + decor planning",
  "Custom premium themes",
];

export const curatedGallery = [
  {
    title: "Luxury Banquet Decor",
    caption: "Premium balloon stage for a banquet celebration.",
    image: "/videos/gallery/look1-luxury-banquet-decor-thumb.jpg",
    video: "/videos/gallery/look1-luxury-banquet-decor.mp4",
    size: "large",
  },
  {
    title: "First Birthday Stage",
    caption: "Milestone birthday stage setup with LED name board.",
    image: "/videos/gallery/look2-first-birthday-stage-thumb.jpg",
    video: "/videos/gallery/look2-first-birthday-stage.mp4",
  },
  {
    title: "Baby Shower Theme",
    caption: "Elegant pastel styling for a family celebration.",
    image: "/videos/gallery/look3-baby-shower-theme-thumb.jpg",
    video: "/videos/gallery/look3-baby-shower-theme.mp4",
  },
  {
    title: "Welcome Baby Setup",
    caption: "Bright home decor for welcoming the newborn.",
    image: "/images/magical-welcome-baby-balloon-decoration-for-home-setup-main-setup-2.webp",
  },
  {
    title: "Cake Table Styling",
    caption: "Coordinated theme table with balloons and props.",
    image: "/videos/gallery/look5-cake-table-styling-thumb.jpg",
    video: "/videos/gallery/look5-cake-table-styling.mp4",
  },
  {
    title: "Return Gift Hampers",
    caption: "Curated gifts for birthday party guests.",
    image: "/videos/gallery/look6-return-gift-hampers-thumb.jpg",
    video: "/videos/gallery/look6-return-gift-hampers.mp4",
  },
];
